import { BoxProps, Grid } from '@cmpsr/components';

export default function DashboardGrid({ children, ...props }: BoxProps) {
  return (
    <Grid
      gridTemplateColumns={{ base: 'auto', lg: '1fr 350px', xl: '1fr 400px' }}
      gap={{ base: 8, lg: 8, xl: 9, xxl: 12 }}
      {...props}
    >
      {children}
    </Grid>
  );
}
